import { Colors } from '@/common/colors/colors';
import SelectInput from '@/common/components/SelectInput';
import { SearchBarColumn } from '@/common/styles/SearchBars';
import React, { useMemo, useState } from 'react';
import { ButtonWrapper, InputsWrapper } from './CCWeeklyReportSearchBar.styled';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { filterProductOptionsByMarket } from '../helpers/filterProductOptionsByMarket';

const CCWeeklyReportSearchBar = ({ formik }) => {
	const {
		options: { marketsOptions, productsOptions },
		commonData: { queues },
	} = useCommonDataContext();
	const productOptionsFiltered = filterProductOptionsByMarket(
		queues,
		productsOptions,
		formik.values.market?.value,
	);

	return (
		<SearchBarColumn>
			<form onSubmit={formik.handleSubmit}>
				<InputsWrapper>
					<SelectInput
						options={formik.values.time_period.period_date_from}
						color={Colors.darkBlue}
						width={130}
						selectWidth={200}
						name='Period from'
						id='period_from'
						setSelected={(value) => {
							formik.setFieldValue('period_from', value);
						}}
						selected={formik.values.period_from}
					/>
					<SelectInput
						options={formik.values.time_period.period_date_to}
						color={Colors.darkBlue}
						width={130}
						selectWidth={200}
						name='Period to'
						id='period_to'
						setSelected={(value) => {
							formik.setFieldValue('period_to', value);
						}}
						selected={formik.values.period_to}
					/>
					<SelectInput
						name='Market'
						options={marketsOptions}
						color={Colors.darkBlue}
						width={130}
						setSelected={(value) => {
							formik.setFieldValue('market', value);
						}}
						selected={formik.market}
						multiple={false}
						selectWidth={200}
						required
					/>
					<SelectInput
						name='Product'
						options={productOptionsFiltered}
						color={Colors.darkBlue}
						width={130}
						setSelected={(value) => {
							formik.setFieldValue('product', value);
						}}
						selected={formik.product}
						multiple={false}
						selectWidth={200}
						required={false}
						disabled={!formik.values.market}
					/>
				</InputsWrapper>

				<ButtonWrapper>
					<SubmitButton color={Colors.orange} text='Search' />
				</ButtonWrapper>
			</form>
		</SearchBarColumn>
	);
};

export default CCWeeklyReportSearchBar;
